import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const getUploadUrl = async (filename, contentType) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_URL}/api/ingredient-receiving/scan/upload-url`,
    { filename, contentType },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data; // { uploadUrl, key }
};

const uploadToS3 = async (uploadUrl, file) => {
  const response = await fetch(uploadUrl, { method: 'PUT', body: file });
  if (!response.ok) throw new Error('S3 upload failed');
};

const scanReceipt = async ({ documentKey, documentOriginalName, contentType }) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_URL}/api/ingredient-receiving/scan`,
    { documentKey, documentOriginalName, contentType },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

const getScan = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/scan/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const confirmScan = async (id, data) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_URL}/api/ingredient-receiving/scan/${id}/confirm`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const discardScan = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_URL}/api/ingredient-receiving/scan/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const pushToQbo = async (id, data) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_URL}/api/ingredient-receiving/scan/${id}/push-to-qbo`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const receiptScanService = {
  getUploadUrl,
  uploadToS3,
  scanReceipt,
  getScan,
  confirmScan,
  discardScan,
  pushToQbo,
};

export default receiptScanService;
